import { createTheme, alpha } from "@mui/material";
import { deepmerge } from "@mui/utils";
import baseThemeOptions from "./baseThemeOptions";

const colorSet = {
  primaryMain: "#ff5d00",
  // Hover tone straight from the brand styleguide — a darkened orange, not a
  // computed variant of primaryMain.
  secondary: "#ef4800",
  link: "#00204b",
  // Lightened rather than darkened: #00204b is already near-black, so a darker
  // hover would be indistinguishable. Replace if the styleguide names a value.
  linkHover: "#264166",
  chatBubble: "#17b2b6",
  defaultTextColor: "#303030",
};

const themeWbsSchools = createTheme(
  deepmerge(baseThemeOptions, {
    palette: {
      primary: {
        main: colorSet.primaryMain,
      },

      secondary: {
        main: colorSet.secondary,
      },

      widgetStyles: {
        minimizedChatBubble: {
          backgroundColor: colorSet.primaryMain,
          iconColor: "#fff",
          hoverColor: colorSet.secondary,
        },

        navbar: {
          backgroundColor: colorSet.primaryMain,
          textColor: "#fff",
          chevronColor: "#fff",
          chevronHoverColor: alpha(colorSet.secondary, 0.4),
        },

        welcomePage: {
          backgroundColor: "#fff",
          textColor: colorSet.defaultTextColor,
          linkColor: colorSet.link,
          linkHoverColor: colorSet.linkHover,
        },

        dataProtectionPage: {
          backgroundColor: "#fff",
          headlineColor: colorSet.defaultTextColor,
          textColor: colorSet.defaultTextColor,
          linkColor: colorSet.link,
          linkHoverColor: colorSet.linkHover,
        },

        button: {
          primary: {
            backgroundColor: colorSet.primaryMain,
            textColor: "#fff",
            hoverColor: colorSet.secondary,
          },
          secondary: {
            backgroundColor: "#17B2B6",
            textColor: colorSet.defaultTextColor,
            hoverColor: "#128B8E",
          },
        },

        userChatBubble: {
          background: alpha(colorSet.chatBubble, 0.2),
          textColor: colorSet.defaultTextColor,
          linkColor: colorSet.link,
          linkHoverColor: colorSet.linkHover,
        },

        botChatBubble: {
          background: alpha(colorSet.defaultTextColor, 0.1),
          textColor: colorSet.defaultTextColor,
          linkColor: colorSet.link,
          linkHoverColor: colorSet.linkHover,
        },

        chatControls: {
          backgroundColor: "#fff",
          iconColor: "#637286",
          iconHoverColor: "#128B8E",
        },
      },
    },

    typography: {
      fontFamily: "wbs-Source-Sans-3",
      color: "red",
      button: {
        fontFamily: "wbs-Source-Sans-3",
      },
      h1: { fontFamily: "wbs-Source-Sans-3" },
      h2: { fontFamily: "wbs-Source-Sans-3" },
      h3: { fontFamily: "wbs-Source-Sans-3" },
      h4: { fontFamily: "wbs-Source-Sans-3" },
      h5: { fontFamily: "wbs-Source-Sans-3" },
      h6: { fontFamily: "wbs-Source-Sans-3" },
    },
  })
);

export default themeWbsSchools;
